<template> 
    <div 
        class="message"  
    >   
        <div 
            v-if="prev.author != item.author || prev.id == item.id"
            class="message__head"
            :class="{
                'message__head_admin': !isClient(item.author)
            }"
        >
            <template v-if="isClient(item.author)">
                <img 
                    :src="getImage(client.big_image)" 
                    alt=""
                    width="30"
                > 
            </template>
            <template v-else>
                <img 
                    src="/images/no-photo-male.jpg" 
                    alt=""
                    width="30"
                > 
            </template>
        </div>
        <div 
            class="message__text"
            :class="{
                'message__text_admin': !isClient(item.author)
            }"
        >
            <template v-if="isImage(item.content)">
                <div class="message__image">
                    <img   
                        :src="item.content" 
                        alt="item.content" 
                        @click="showImage(item.content)"
                    >
                </div> 
            </template>
            <template v-else>
                <p>{{item.content}}</p>
            </template> 
        </div>
        <div 
            class="message__date mb10"
            :class="{
                'message__date_admin': !isClient(item.author)
            }"
        >
            <span>{{formatOrderDate(item.datetime * 1000)}}</span>
        </div>
    </div> 
</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
import dateMixin from '@/mixins/date';
import image from '@/mixins/image';

export default {
    name: 'message-item',
    props: {
        item: {
            required: true,
            type: Object
        },
        prev: {
            required: true,
            type: Object
        }
    },
    mixins: [dateMixin, image],
    computed: {
        ...mapGetters({ 
            client: 'client/client'
        }),
    }, 
    methods: {
        ...mapMutations({
            setState: 'imageModal/setState'
        }), 
        isClient(v) {
            return v === 'self'
        },  
        isImage(v) {
            return v.includes('.png') || v.includes('.jpg') || v.includes('.svg')
        },
        getAuthor(v) {
            return this.isClient(v) ? ' You ' : ' Admin '
        },  
        showImage(img) {
            this.setState({
                key: 'src',
                value: img
            })

            this.setState({
                key: 'isShow',
                value: true
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.message {
    &__text {
        width: 100%; 
        display: flex;
        justify-content: flex-end;
        padding: 0 45px;
        
        p {
            padding: 14px 16px;
            width: auto;
            max-width: 100%;
            background: rgba(155, 205, 130, 0.2);
            border-radius: 20px; 
        }

        &_admin {
            justify-content: flex-start;

            p {
                background: rgba(220, 91, 38, 0.2);
            }
        }
    }

    &__date {
        margin-top: 2px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding: 0 38px;

        span {
            font-family: 'crossten'; 
            font-weight: 600;
            font-size: 10px;
            line-height: 15px; 
            color: rgba(39, 40, 56, 0.3);
        }
         
        &_admin {
            justify-content: flex-start;
        }
    }

    &__head {
        width: 100%;
        height: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center; 
        position: relative;
        top: 16px;
        right: -2px;

        img {
            display: inline-block;
            margin-left: 2px;
            order: 2;
            border-radius: 50%;
        }

        span {
            order: 1;
        }

        &_admin {
            justify-content: flex-start;
            right: 2px;

            img { 
                margin-right: 2px;
                order: 1;
            }

            span {
                order: 2;
            }
        }
    }   

    &__image {
        width: 200px;
        height: 200px;
        padding: 10px;
        border-radius: 10px;
        background: rgba(155, 205, 130, 0.2);
        position: relative;

        img {   
            display: block;
            width: 180px;
            height: 180px;
            object-fit: contain; 
            position: relative;
            cursor: zoom-in;
        }
    }
} 
</style>